// Request identity for state owned by one `latest` request (see middleware/api.jsx).
//
// On the start action a reducer stores `action.latestRequestId`; on result/error it accepts only
// the action whose id matches. Cancellation stops superseded requests; this check makes sure
// that only the request the state is waiting for can fill it, even if a cancellation is
// missed or another dispatcher uses the same action type.
export const isLatestResult = (expectedRequestId, action) => action.latestRequestId === expectedRequestId;
